import React, { Component, Fragment } from 'react';
import {
    BASE_URL_ADMIN
} from '../../../data/config';
class Suplier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            imageIdShow: 0,
            items: [
                
            ],
        }
    }
    showImage(imageIdShow, e) {
        e.preventDefault();
        this.setState({ show: true, imageIdShow });
        this.initJquery();
    }
    hiddenImage(e) {
        e.preventDefault();
        this.setState({ show: false });   
    }
    changeImageShow(type, e) {
        e.preventDefault();
        let items = this.props.listGallery;
        let { imageIdShow } = this.state;
        if (type == "next") {
            imageIdShow += 1;
            if (imageIdShow >= items.length) imageIdShow = items.length - 1;
        } else if (type == "previous") {
            imageIdShow -= 1;
            if (imageIdShow <= 0) imageIdShow = 0;
        }
        this.setState({ imageIdShow });
        this.initJquery();
    }
    componentDidUpdate = () => {
        this.initJquery();
    }
    initJquery() {
        let self = this;
        jQuery(document).ready(function($) {
        // window.addEventListener("load", function() {
            $('.page-see-more .description-lightbox').removeClass('show-less-hide');
            var heightDetail = $('.page-see-more .description-lightbox');
            if($(heightDetail).height() > 40){
                $(heightDetail).addClass('show-less-hide');
                $(heightDetail).parent().find('.read-more').show();
                $(heightDetail).parent().find('.read-more').html('Read More.. >>');
            }
            else{
                // $('.page-see-more .read-more').hide();
                $(heightDetail).parent().find('.read-more').hide();
                $(heightDetail).parent().find('.read-more').html('Show Less.. >>');
            }
        });
    }
    renderListGallery() {
        return this.props.listGallery.slice(0, 4).map((item,index) => {
            return (
                <div className="img-gallery" key={index}>
                    <a href="#"><img src={ BASE_URL_ADMIN + item.image } onClick={ this.showImage.bind(this , index)} alt="Ruhu Gallery"/></a>
                </div>
            );
        });
    }
    render() {
        const filtered = this.props.listGallery;
        const count = filtered.length;
        return (
            <Fragment>
                <div className="gallery">
                    <div className="container">
                        <h3 className="title-detail">Gallery</h3>
                            { (count > 0) ? ( 
                                <div className="list-gallery">
                                    <div className="col-gallery col-gallery-1">
                                        <div className="img-gallery img-gallery-large img-hover">
                                            <a href="#"><img src={BASE_URL_ADMIN + filtered[0].image} onClick={ this.showImage.bind(this, 0)} alt="Ruhu Gallery"/></a>
                                        </div>
                                    </div>
                                    { (count >= 2) ? (
                                        <div className="col-gallery col-gallery-2">
                                            <div className="img-gallery img-hover">
                                                <a href="#"><img src={BASE_URL_ADMIN + filtered[1].image} onClick={ this.showImage.bind(this , 1)} alt="Ruhu Gallery"/></a>
                                            </div>
                                            { (count > 2) ? (
                                                <div className="img-gallery img-hover">
                                                    <a href="#"><img src={BASE_URL_ADMIN + filtered[2].image} onClick={ this.showImage.bind(this, 2)} alt="Ruhu Gallery"/></a>
                                                </div>
                                            ) : ''}
                                            { (count > 3) ? (
                                            <div className="img-gallery img-hover">
                                                <a href="#"><img src={BASE_URL_ADMIN + filtered[3].image} onClick={ this.showImage.bind(this,3)} alt="Ruhu Gallery"/></a>
                                            </div>
                                            ) : ''}
                                            { (count > 4) ? (
                                            <div className="img-gallery img-hover">
                                                <a href="#"><img src={BASE_URL_ADMIN + filtered[4].image} onClick={ this.showImage.bind(this,4)} alt="Ruhu Gallery"/></a>
                                            </div>
                                            ) : ''}
                                        </div>
                                    ) : ''}
                                    
                                </div> 
                                
                                ) : ''
                            }
                            {/*{ this.renderListGallery() }*/}
                    </div>

                    { (this.state.show == true) ? (
                        <div className="lightbox">
                        <div className="sldier-lightbox">
                            <div className="container-lightbox">
                            
                                    <button className="btn-lightbox btn-left" onClick={ this.changeImageShow.bind(this, 'previous') }><img src={'/images/left.png'} alt="Ruhu"/></button>
    
                                    <button className="btn-lightbox btn-right" onClick={ this.changeImageShow.bind(this, 'next') }><img src={'/images/right.png'} alt="Ruhu"/></button>

                                <div className="wrapper-lightbox">
                                    <div className="item-lightbox">
                                        <div className="click-body" onClick={this.hiddenImage.bind(this)}></div>
                                        <div className="inline-item-wrapper">
                                            <button className="close-lightbox" onClick={this.hiddenImage.bind(this)} >&times;</button>
                                            <div className="inline-item">
                                                <div className="img-inline-item">
                                                    <a href={this.props.listGallery[this.state.imageIdShow].link} target="_blank"><img src={ BASE_URL_ADMIN +  this.props.listGallery[this.state.imageIdShow].image } alt="Ruhu Gallery"/></a>
                                                </div>
                                                <div className="info page-see-more">
                                                    <div className="title">{ this.props.listGallery[this.state.imageIdShow].name }</div>
                                                    <div className="description-lightbox">{ this.props.listGallery[this.state.imageIdShow].description }</div>
                                                    <div className="read-more text-right">Read More.. >></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        ) : null}
                </div>
            </Fragment>
        );
    }
}

export default Suplier